import React from 'react';
import { FaTrophy, FaStar, FaRocket, FaUsers } from 'react-icons/fa';
import './Achievements.css';

const Achievements = () => {
  const achievements = [
    {
      icon: <FaRocket />,
      title: "Cut the manual follow-up load",
      description: "Built Twilio-based SMS automation for patient follow-ups so staff weren't chasing people by phone all day.",
      impact: "~60% fewer manual follow-ups"
    },
    {
      icon: <FaStar />,
      title: "Made the APIs noticeably faster",
      description: "Reworked MongoDB aggregation pipelines on the healthcare app and trimmed response times on the slow endpoints.",
      impact: "~40% faster API responses"
    },
    {
      icon: <FaUsers />,
      title: "Put control in the right hands",
      description: "Built a dynamic UI config system and a CMS so admins and marketing could make changes themselves instead of waiting on engineering.",
      impact: "Fewer dev tickets for content changes"
    }
  ];

  return (
    <section id="achievements" className="achievements">
      <div className="container">
        <h2 className="section-title">
          <FaTrophy className="title-icon" />
          Key Achievements & Impact
        </h2>
        
        <div className="achievements-grid">
          {achievements.map((achievement, index) => (
            <div key={index} className="achievement-card">
              <div className="achievement-icon">
                {achievement.icon}
              </div>
              
              <div className="achievement-content">
                <h3>{achievement.title}</h3>
                <p>{achievement.description}</p>
                <div className="achievement-impact">
                  <span className="impact-label">Impact:</span>
                  <span className="impact-value">{achievement.impact}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="achievements-summary">
          <div className="summary-content">
            <h3>The through-line</h3>
            <p>
              None of these were huge rewrites. They were the kind of practical wins that add up:
              automate the thing people hate doing, speed up the query everyone complains about, and
              hand control back to the people who actually need it. That's the sort of work I gravitate
              toward.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Achievements;
